<template>
  <div class="email-info">
    <input
      type="text"
      :value="value"
      @focus="setLastSelectedEmail(index)"
      @input="setEmail({ index: index, value: $event.target.value })"
      name="email-1"
      placeholder="snow@gmail.com"
    />
    <a href="#" class="email-delete" @click.prevent="removeEmail(index)">
      <img src="../../../assets/img/m_trash.png" alt="Delete" />
    </a>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  props: {
    index: Number,
    value: String,
    setLastSelectedEmail: Function
  },
  methods: {
    ...mapMutations("addNew", {
      setEmail: "setEmail",
      removeEmail: "removeEmail"
    })
  }
};
</script>

<style scoped>
.sticky-header .header-icon-contain img {
  width: auto;
}
</style>
